import React, { lazy } from 'react';
import { Spinner } from 'ui-kit';
import { TypeModal } from 'types/rootState';
import useSetting from './useSetting';

const SettingsComponent = lazy(() => import('components/settings/settings'));

export function Settings() {
  const {
    settingsParamsChanges,
    settingsUserModal,
    activateModal,
    setConfirmDialogData,
    setSettingsHostessModal,
    intlUtils,
    date,
    restaurant,
    selectedPlaces,
    userList,
    allUsers,
    setSettingsEditStatusModal,
  } = useSetting();

  return (
    <React.Suspense fallback={<Spinner />}>
      <SettingsComponent
        intlUtils={intlUtils}
        rest={restaurant.restaurant_id}
        places={selectedPlaces}
        date={date}
        onCallModalParamsChange={(params) => {
          Object.assign(settingsParamsChanges, params);
          activateModal(TypeModal.changesParams, 'guest-card');
        }}
        onCallModalHostess={(hostess, restId) => {
          setSettingsHostessModal({ hostess, restId });
          activateModal(TypeModal.changeHostess, 'guest-card');
        }}
        onCallModalConfirm={(id, mode) => {
          setConfirmDialogData({ data: id, mode });
          activateModal(TypeModal.confirm, 'guest-card');
        }}
        onCallModalUser={(user, role) => {
          Object.assign(settingsUserModal, {
            user: user ? { ...user } : undefined,
            role,
          });
          activateModal(TypeModal.changeUser, 'guest-card');
        }}
        onCallModalStatus={(allStatuses, statusId, editStatus, isEditing) => {
          setSettingsEditStatusModal({
            allStatuses,
            statusId,
            editStatus,
            isEditing,
          });
          activateModal(TypeModal.status, 'guest-card');
        }}
        userList={userList}
        allUsers={allUsers}
      />
    </React.Suspense>
  );
}
